import { render } from "./RequeteList.vue?vue&type=template&id=4fafa73f"
import script from "./RequeteList.vue?vue&type=script&lang=js"
export * from "./RequeteList.vue?vue&type=script&lang=js"

import "./RequeteList.vue?vue&type=style&index=0&id=4fafa73f&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__